import { lazy } from '../../shared/deployment';

export const DayjsRelativeTime = lazy(() => import('./DayjsRelativeTime'));
export const CountDown = lazy(() => import('./CountDown'));
export const ItemStatus = lazy(() => import('./ItemStatus'));
